export const API_PATH = 'https://meichu.games/api'
